/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_IntroInputs */

const en_how_we_work_intro = /** @type {(inputs: How_We_Work_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We work alongside your team, from understanding the problem to a system that runs, whether that is one task or a whole operation.`)
};

const lv_how_we_work_intro = /** @type {(inputs: How_We_Work_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strādājam kopā ar Jūsu komandu — no problēmas izpratnes līdz sistēmai, kas strādā, vai tas būtu viens uzdevums vai vesels process.`)
};

/**
* | output |
* | --- |
* | "We work alongside your team, from understanding the problem to a system that runs, whether that is one task or a whole operation." |
*
* @param {How_We_Work_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_intro = /** @type {((inputs?: How_We_Work_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_intro(inputs)
	return en_how_we_work_intro(inputs)
});